import { render, staticRenderFns } from "./ImagenClientes.vue?vue&type=template&id=8b691eaa&lang=pug"
import script from "./ImagenClientes.vue?vue&type=script&lang=js"
export * from "./ImagenClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports